const CompanyName = {
  get () {
    return 'C'
  },
  set (value) {
  },
  isValid () {
  }
}

class Hoge {
  constructor (name) {
    this.value = 'hoge'
  }
  get () {
    return name
  }
  set (value) {
  }
}

export { CompanyName, Hoge }



// WEBPACK FOOTER //
// ./src/components/CompanyName.js